import { z } from 'zod'

export const policyFormSchema = z.object({
  policy_name: z.string().min(1, 'Policy name is required'),
  policy_group: z.string().min(1, 'Policy group is required'),
  policy_description: z.string().min(1, 'Policy description is required'),
})

export type PolicyFormValues = z.infer<typeof policyFormSchema>
